import React from 'react';
import { Card, CardHeader, CardBody, Row, Col } from 'react-bootstrap';
import { formatDate } from '../../../../helper/formatDate';
import {
    getStatusBadge,
    getServiceBadgeClass,
    openGoogleMap
} from '../EnquiryList/enquiryUtils';

export const EnquiryStatusCard = ({ report, trialStatus, latestFollowup, trialEndDate }) => {
    if (!report) return null;

    const currentStatus = getStatusBadge(latestFollowup?.status || report.status);
    const serviceName = report.course?.name || 'N/A';
    const serviceBadgeClass = getServiceBadgeClass(serviceName);
    const createdByName = report.created_by
        ? `${report.created_by.first_name} ${report.created_by.last_name || ''}`.trim()
        : 'System';

    return (
        <Card className="border-0 shadow-sm rounded-3 mb-3">
            <CardHeader className="py-3 px-4 border-bottom bg-light-subtle d-flex align-items-center justify-content-between">
                <h5 className="card-title mb-0 fs-15 fw-bold text-dark">Enquiry & Service Status</h5>
                <span className={`badge bg-soft-${currentStatus.color} text-${currentStatus.color} fs-11 px-2.5 py-1 text-capitalize fw-semibold`}>
                    {currentStatus.label}
                </span>
            </CardHeader>
            <CardBody className="p-3 p-md-4">
                <Row className="g-3">
                    {/* Left Column: Enquiry Information */}
                    <Col md={6} xs={12}>
                        <div className="p-3 bg-light-subtle rounded-3 border border-light-subtle h-100">
                            <h6 className="fs-12 fw-bold text-uppercase text-muted mb-2.5">
                                <i className="ri-information-line me-1 text-primary" />
                                Enquiry Details
                            </h6>

                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light fs-13">
                                <span className="text-muted">Enquiry By:</span>
                                <span className="fw-semibold text-dark">{createdByName}</span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light fs-13">
                                <span className="text-muted">Current Follow-Up:</span>
                                <span className={`badge bg-soft-${currentStatus.color} text-${currentStatus.color} fs-11 px-2 py-0.5`}>
                                    {currentStatus.label}
                                </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light fs-13">
                                <span className="text-muted">Preferred Service:</span>
                                <span className={`service-pill-badge ${serviceBadgeClass} fs-11`}>
                                    {serviceName}
                                </span>
                            </div>

                            {/* Location replacing Feedback */}
                            <div className="d-flex justify-content-between align-items-center py-2 fs-13">
                                <span className="text-muted">Location:</span>
                                {report.feedback ? (
                                    <button
                                        type="button"
                                        onClick={() => openGoogleMap(report.feedback)}
                                        className="btn btn-sm btn-soft-danger py-0.5 px-2 fs-12 d-inline-flex align-items-center gap-1"
                                        title="Open Location in Google Maps"
                                    >
                                        <i className="ri-map-pin-2-fill fs-13" />
                                        <span>Google Map</span>
                                    </button>
                                ) : (
                                    <span className="text-muted fst-italic">Not specified</span>
                                )}
                            </div>
                        </div>
                    </Col>

                    {/* Right Column: Trial Details */}
                    <Col md={6} xs={12}>
                        <div className="p-3 bg-light-subtle rounded-3 border border-light-subtle h-100">
                            <h6 className="fs-12 fw-bold text-uppercase text-muted mb-2.5">
                                <i className="ri-timer-line me-1 text-info" />
                                Trial Details
                            </h6>

                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light fs-13">
                                <span className="text-muted">Trial Status:</span>
                                {trialStatus ? (
                                    <span className={`badge ${trialStatus.badgeClass} fs-11 px-2 py-0.5`}>
                                        {trialStatus.label}
                                    </span>
                                ) : (
                                    <span className="text-muted fst-italic">No Trial</span>
                                )}
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light fs-13">
                                <span className="text-muted">Trial Start Date:</span>
                                <span className="fw-semibold text-dark">
                                    {report.tryal_date ? formatDate(report.tryal_date) : '-'}
                                </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light fs-13">
                                <span className="text-muted">Trial End Date:</span>
                                <span className="fw-semibold text-dark">
                                    {trialEndDate ? formatDate(trialEndDate) : '-'}
                                </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-2 fs-13">
                                <span className="text-muted">Trial Period:</span>
                                <span className="fw-semibold text-dark">
                                    {report.tryal_period ? `${report.tryal_period} Days` : '0 Days'}
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default EnquiryStatusCard;
